export default __webpack_public_path__ + "static/media/glamstyle.8c0fb70d.png";